<template>
    <div class="gh-location-select" v-click-outside="handleClickOutside">
        <div class="gh-location gh-trigger" @click="showLocations = !showLocations">
            <img :src="location.icon" :alt="`${location.name} flag`" class="gh-flag" width="20" height="20" loading="lazy">
            <i :class="arrowClassList"></i>
        </div>

        <el-collapse-transition>
            <div v-show="showLocations" class="gh-location-modal" :style="modalStyles" ref="modal">
                <span class="gh-location-hint">
                    You are currently on our {{ location.name }} website. Not your location? Select one of the options below to change your location.
                </span>
                <ul :class="locationsClassList">
                    <li
                            v-for="location in locationOptions"
                            :key="location.name"
                            class="gh-location"
                            @click="handleChange(location)">
                        <img :src="location.icon" :alt="`${location.name} flag`" class="gh-flag" width="20" height="20" loading="lazy">
                        <span class="gh-name">{{ location.name }}</span>
                    </li>
                </ul>
            </div>
        </el-collapse-transition>
    </div>
</template>

<script>
    import vClickOutside from 'v-click-outside'

    export default {
        name: 'gh-location-select',

        directives: {
            clickOutside: vClickOutside.directive
        },

        props: {
            modalStyles: {
                type: Object,
                default: () => {}
            },

            inline: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                location: this.$options.locations[0],
                showLocations: false
            }
        },

        computed: {
            locationOptions() {
                return _.orderBy(this.$options.locations.filter(location => location.name !== this.location.name), ['name'])
            },

            arrowClassList() {
                return this.showLocations ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
            },

            locationsClassList () {
                return [
                    'gh-locations',
                    this.inline ? 'is-inline' : ''
                ]
            }
        },

        methods: {
            handleChange(location) {
                window.location.href = location.url
            },

            handleClickOutside () {
                this.showLocations = false
            }
        },

        locations: [
            {name: 'AUS', icon: '/images/app/flag-au.svg', url: 'https://mentalhealthacademy.com.au'},
            {name: 'UK', icon: '/images/app/flag-uk.svg', url: 'https://mentalhealthacademy.co.uk'},
            {name: 'US', icon: '/images/app/flag-us.svg', url: 'https://mentalhealthacademy.net'}
        ]
    }
</script>

<style lang="scss" scoped>
    .gh-location-select {
        position: relative;
    }

    .gh-location-modal {
        position: absolute;
        width: 300px;
        padding: 1rem .5rem;
        background: #F7F7F7;
        z-index: 1;
    }

    .gh-location {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .gh-location-hint {
        display: block;
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.2;
        word-break: break-word;
    }

    .gh-locations {
        margin-top: .5rem;
    }

    .gh-location {
        + .gh-location {
            margin-top: .5rem;
        }

        .is-inline & {
            display: inline-flex;

            + .gh-location {
                margin-top: 0;
                margin-left: 2rem;
            }
        }
    }

    .gh-flag {
        width: 20px;
        margin-right: 1rem;

        .gh-trigger &,
        .is-inline & {
            margin-right: .5rem;
        }
    }

    .gh-name {
        font-weight: 500;
    }
</style>
